<template>
  <DialogContainer v-model="dialogObj" v-if="dialogObj.show">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form custom-wyq" v-loading="loading">
        <div class="tip">
          <i class="el-icon-warning"></i>请使用微信扫码支付
        </div>
        <div style="text-align: center;line-height: 2;font-size: 20px">
          支付金额：<span class="color1966ff" style="font-size: 30px">{{detailData.payableFee}}</span>元
        </div>
        <div ref="qrcode" id="qrcode" class="qr-code"></div>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import QRCode from "qrcodejs2";
import { getWxPayQr, getWxPayStatus } from "@/views/commonApi";

export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "微信扫码支付",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: () => {
          // 关闭弹窗：清理定时器、二维码实例
          this.clearTimer();
          this.destroyQrcode();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      qrcode: null,
      timer: null,
      orderId: "",
      detailData: {},
      // 轮询最大时长 180秒（30分钟，二维码有效期）
      pollMaxTime: 180 * 1000 * 10,
      pollStartTime: null,
    };
  },
  beforeDestroy() {
    this.clearTimer();
    this.destroyQrcode();
  },
  methods: {
    // 清理定时器
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // 销毁二维码实例
    destroyQrcode() {
      if (this.qrcode) {
        this.qrcode.clear();
        this.qrcode = null;
      }
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = "";
      }
    },
    generateQRCode() {
      const qrcodeContainer = this.$refs.qrcode;
      if (!qrcodeContainer) return;
      this.destroyQrcode();
      this.qrcode = new QRCode(qrcodeContainer, {
        text: this.detailData.codeUrl,
        width: 300,
        height: 300,
      });
    },
    async pollOrderPayStatus() {
      return new Promise((resolve) => {
        this.clearTimer();
        this.pollStartTime = Date.now();
        this.timer = setInterval(async () => {
          // 超时判断
          if (Date.now() - this.pollStartTime >= this.pollMaxTime) {
            this.clearTimer();
            this.$message.warning("二维码已过期，请重新生成");
            resolve(false);
            return;
          }
          try {
            const res = await getWxPayStatus(this.orderId);
            if (res.code === 200 && res.data.paymentStatus === 1) {
              this.clearTimer();
              resolve(true);
            }
          } catch (err) {
            console.error("查询支付状态失败：", err);
          }
        }, 3000);
      });
    },
    getPayQrImage(orderId) {
      this.loading = true;
      this.clearTimer();
      this.destroyQrcode();
      getWxPayQr({ orderId })
        .then(async (res) => {
          this.loading = false;
          if (res.code === 200) {
            this.detailData = res.data;
            await this.$nextTick();
            this.generateQRCode();
            // 二维码渲染完立刻开始轮询，移除5s延迟
            const payResult = await this.pollOrderPayStatus();
            if (payResult) {
              this.$emit("paySuccess");
              this.$message.success("支付成功")
              this.dialogObj.show = false;
            }
          } else {
            this.$message.error("获取支付二维码失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("请求二维码接口异常");
        })

    },
    init(orderId) {
      this.detailData = { payableFee: "", codeUrl: "" };
      this.orderId = orderId;
      this.dialogObj.show = true;
      this.getPayQrImage(orderId);
    },
    submitForm() {
      // 如果不需要确认按钮，可以删掉或者置空
    },
  },
};
</script>

<style scoped lang="scss">
.custom-wyq {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .tip {
    display: flex;
    align-items: center;
    font-size: 20px;

    i {
      font-size: 24px;
      margin-right: 2px;
      color: #cf9236;
    }
  }

  .qr-code {
    margin: 40px;
    min-height: 240px;
  }
}
</style>
